import { API_URL } from '@/constants/apiUrl'

export const getDocumentUrl = (documentId?: string, service?: string): string => {
  if (!documentId) {
    return ''
  }

  if (!service || service === 'electronic-id') {
    return `${API_URL}/electronic-id/redirect-to-presigned-pdf-url?fileId=${documentId}`
  }

  return `${API_URL}/${service}/redirect-to-presigned-pdf-url?documentId=${documentId}`
}
